<template>
    <div class="composer-menu-area">
        <div class="form-group">
            <div class="row">
                <div class="col-12">
                    <label for="journey-selector">{{resource('JourneyBuilder_Shared_Journey')}}</label>
                    <journey-dropdown
                        id="journey-selector"

                        @input="$emit('update:journeyId', $event)"
                        :value="journeyId"
                    />
                </div>
            </div>
        </div>
        
        <menu-controls 
            :showSaveButton="showSaveButton"
            :showUnlockButton="showUnlockButton"
            :showCloneButton="showCloneButton"
            :isValidForm="isValidForm"

            @save="saveClick"
            @unlock="unlockClick"
            @clone="cloneClick"
        />

        <menu-brick-toolbox
            :journeyType="journeyType"
            @add-brick="$emit('add-brick', $event)"
        >
        </menu-brick-toolbox>

        <div class="text-center">
            <label>Journey Composer bricks</label>
        </div>
        
        <hr />

        <div class="text-center">
            <label>Connectie checkpoints</label>
        </div>
        
        <menu-checkpoint-toolbox />
        
        <menu-journey-filters />
        
        <menu-edit-form
            ref="editForm"
                
            :journey-name="journeyName"
            :journey-world="journeyWorld"
            :journey-description="journeyDescription"
            :journey-start-date="journeyStartDate"
            :journey-end-date="journeyEndDate"
            :journey-is-active="journeyIsActive"
            :journey-division-id="journeyDivisionId"
            :journey-type="journeyType"
            
            v-on:update:journeyName="$emit('update:journeyName', $event)"
            v-on:update:journeyWorld="$emit('update:journeyWorld', $event)"
            v-on:update:journeyDescription="$emit('update:journeyDescription', $event)"
            v-on:update:journeyStartDate="$emit('update:journeyStartDate', $event)"
            v-on:update:journeyEndDate="$emit('update:journeyEndDate', $event)"
            v-on:update:journeyIsActive="$emit('update:journeyIsActive', $event)"
            v-on:update:journeyDivisionId="$emit('update:journeyDivisionId', $event)"
            v-on:update:journeyType="$emit('update:journeyType', $event)"
        >    
        </menu-edit-form>

        <menu-controls
            :showSaveButton="showSaveButton"
            :showUnlockButton="showUnlockButton"
            :showCloneButton="showCloneButton"
            :isValidForm="isValidForm"

            @save="saveClick"
            @unlock="unlockClick"
            @clone="cloneClick"
        />

    </div>
</template>

<script>
    import resourceMixin from "@core/Util/Mixins/resources";
    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

    import JourneyDropdown from '@modules/JourneyBuilder/Components/Elements/JourneyDropdown';
    import MenuControls from './MenuControls';
    import MenuBrickToolbox from "./MenuBrickToolbox";
    import MenuEditForm from "./MenuEditForm";
    import MenuCheckpointToolbox from "./MenuCheckpointToolbox";
    import MenuJourneyFilters from './MenuJourneyFilters';
    import Modal from '@core/Components/Util/Modal';
    
    export default {
        name: 'menu-area',
        components: {
            JourneyDropdown,
            MenuControls,
            MenuBrickToolbox,
            MenuEditForm,
            MenuCheckpointToolbox,
            MenuJourneyFilters,
            Modal
        },
        mixins: [resourceMixin, permissionsMixin],
        mounted() {
            this.isMounted = true;
        },
        methods: {
            saveClick(){
                if(!this.isValidForm){
                    return;
                }

                this.$emit('save');
            },
            unlockClick(){
                if(!this.isValidForm){
                    return;
                }

                this.$emit('unlock');
            },
            cloneClick(){
                this.$emit('clone');
            }
        },
        computed: {
            isValidForm(){
                //Form still needs to render
                if(!this.isMounted){
                    return false;
                }
                
                return !this.$refs.editForm.$v.$invalid;
            },
            showSaveButton(){
                return this.canWrite;
                // return this.canWrite && !this.isLocked;
            },
            showUnlockButton(){
                //TODO: Implement locking/unlocking of journeys
                return false;
                // return this.canWrite && this.isLocked;
            },
            showCloneButton(){
                //Having an id  and write permissions means a journey can be cloned
                return !!this.journeyId && this.hasWritePermission;
            }
            // showLockButton(){
            //     return this.canWrite && !this.isLocked; 
            // },
            // showUnlockButton(){
            //     return this.canWrite && this.isLocked;
            // }
        },
        data() {
            return {
                isMounted: false
            }
        },
        props: {
            journeyId: null,
            
            journeyName: '',
            journeyWorld: '',
            journeyType: 0,
            journeyDescription: '',
            journeyStartDate: null,
            journeyEndDate: null,
            journeyIsActive: false,
            journeyDivisionId: undefined
        }
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/journey-builder-menu-brick-composer.scss";
</style>
